import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { UpgradeRequestsListPage } from '@/pages/upgrade-requests/upgrade-requests-list-page';

/** status: omitted = pending (the actionable inbox); 'all' = every status. */
const SearchSchema = z.object({
  status: z.enum(['pending', 'granted', 'declined', 'cancelled', 'all']).optional().catch(undefined),
  offset: z.coerce.number().int().min(0).optional().catch(undefined),
});
export type UpgradeRequestsSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute('/upgrade-requests/')({
  component: UpgradeRequestsListPage,
  validateSearch: (s) => SearchSchema.parse(s),
});
